import './faq.scss';
import { headerHeight } from '../../scripts/helpers';

if (!window.dAgency) window.dAgency = {};
window.dAgency.InitFaq = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const menu = sectionContainer.querySelector('.faq__text-container');

  function stickyMenu (){
    const rect = menu.getBoundingClientRect();

    if (rect.top === 0) {
      menu.style.top = '0px';
    } else {
      menu.style.top = headerHeight() + 'px';
    }
  }

  window.addEventListener('load', () => {
    stickyMenu();
  });

  window.addEventListener('scroll', () => {
    stickyMenu();
  });

  const spacing = sectionContainer.querySelector('.spacing__5').clientHeight;
  sectionContainer.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();

      const target = sectionContainer.querySelector(this.getAttribute('href'));

      window.scrollTo({
          top: target.offsetTop - (headerHeight() + spacing)
      });
    });
  });
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.faq__section'), (el) => {
    window.dAgency.InitFaq(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.faq__section'), (el) => {
      window.dAgency.InitFaq(el);
    });
  });
}
